import CustomRangeSelect, {
  TCustomRangeSelectType,
} from '../components/CustomRangeSelect';
import { CustomRangeSelectButton } from '../components/CustomRangeSelect/CustomRangeSelectButton';
import { TComponentConfig } from '../types';
import {
  getRangeSelectDefaultValue,
  getRangeSelectBackValueFunc,
  createRangeSelectOption,
} from '../utils';

export const TopNewVideoViews: TComponentConfig<TCustomRangeSelectType> = {
  Component: CustomRangeSelect,
  ButtonComponent: CustomRangeSelectButton,
  defaultValue: getRangeSelectDefaultValue,
  backValue: getRangeSelectBackValueFunc(1000 * 1000),
  props: {
    title: 'Top 500 New Video Views',
    titleCn: 'Top 500 新增视频观看量',
    valueKeys: 'total_views',
    addOption: createRangeSelectOption,
    unit: 'M',
    options: [
      { text: 'All', textCn: '全部', value: 'all' },
      { text: '0M-50M', textCn: '0M-50M', value: '0-50' },
      { text: '50M-100M', textCn: '50M-100M', value: '50-100' },
      { text: '100M-500M', textCn: '100M-500M', value: '100-500' },
      { text: '500M-1B', textCn: '500M-1B', value: '500-1000' },
      { text: '1B+', textCn: '1B+', value: '1000-' },
    ],
  },
};

export const TopNewVideoLikes: TComponentConfig<TCustomRangeSelectType> = {
  Component: CustomRangeSelect,
  ButtonComponent: CustomRangeSelectButton,
  defaultValue: getRangeSelectDefaultValue,
  backValue: getRangeSelectBackValueFunc(1000 * 1000),
  props: {
    title: 'Top 500 New Video Likes',
    titleCn: 'Top 500 新增视频点赞量',
    valueKeys: 'total_likes',
    addOption: createRangeSelectOption,
    unit: 'M',
    options: [
      { text: 'All', textCn: '全部', value: 'all' },
      { text: '0M-50M', textCn: '0M-50M', value: '0-50' },
      { text: '50M-100M', textCn: '50M-100M', value: '50-100' },
      { text: '100M-500M', textCn: '100M-500M', value: '100-500' },
      { text: '500M-1B', textCn: '500M-1B', value: '500-1000' },
      { text: '1B+', textCn: '1B+', value: '1000-' },
    ],
  },
};
